import React from 'react';

export default function Navbar() {
  const scrollToWaitlist = (e) => {
    e.preventDefault();
    document.getElementById('waitlist-cta')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      <img src="/logo-header.png" alt="Pramaan Digital Signatures" className="navbar-logo" />
      <a href="#waitlist-cta" className="navbar-cta" onClick={scrollToWaitlist}>
        Join Waitlist
      </a>
    </nav>
  );
}
